import React from 'react';
import { News } from '../components/news';
import { CTAPromo } from '../components/cta-promo';
import { FanChoice } from '../components/fan-choice';
import { Tickets } from '../components/tickets';
import { Divider } from '../components/dividers';
import { Signup } from '../components/sign-up';
import { Video } from '../components/video';
import { Profiles } from '../components/profiles';
import { FaqsBlock } from '../components/faq';
import { Countdown } from '../components/countdown';
import HeroCarousel from '../components/hero-carousel';
import MediaKit from '../components/media-kit';
import LeftAlignedPromo from '../components/left-aligned-promo';
import NewsGroup from '../components/news-group';
import TitleAndText from '../components/title-text';

/**
 * GetComponent
 * @param {object} contentfulEntry Component from contentful
 * @param {object} allContentfulNewsArticle All possible articles
 * @param {object} allContentfulTeam All possible teams
 * @param {int} index inxed of component
 * @param {object} dataJson relevent data object
 * @param {string} mailchimpUrl url for the mailchimp api
 * @param {string} ticketMasterLink external link
 * @param {string} ticketMasterButtonText text for reserve ticket button
 * @returns {XML} A component depending on the input
 * @param {string} twitterHashTag for main tweet hash tag;
 * @param {number} twitterCharacterLimit for tweet character limitation;
 */
const GetComponent = ({
  component,
  allContentfulNewsArticle,
  allContentfulTeam,
  index,
  dataJson,
  mailchimpUrl,
  ticketMasterLink,
  ticketMasterButtonText,
  showCities,
  twitterHashTag,
  twitterCharacterLimit,
  privacyModal,
  termsModal,
}) => {
  const key = `component.__typename${index}`;
  let outComponent = <div key={key} />;
  switch (component.__typename) {
  case 'ContentfulHeroCarousel':
    outComponent = <HeroCarousel key={key} {...component} />;
    break;
  case 'ContentfulTickets':
    outComponent = showCities ? (
      <Tickets
        key={key}
        {...component}
        teams={allContentfulTeam}
        ticketMasterLink={ticketMasterLink}
        ticketMasterButtonText={ticketMasterButtonText}
      />
    ) : null;
    break;
  case 'ContentfulDividerPromo':
    outComponent = <Divider key={key} {...component} />;
    break;
  case 'ContentfulCountdownTimer':
    outComponent = <Countdown key={key} {...component} />;
    break;
  case 'ContentfulFeaturedNewsAndCarousel':
    outComponent = <News key={key} {...component} articles={allContentfulNewsArticle} />;
    break;
  case 'ContentfulTwitter':
    outComponent = (
      <FanChoice
        key={key}
        {...component}
        dataJson={dataJson}
        twitterHashTag={twitterHashTag}
        twitterCharacterLimit={twitterCharacterLimit}
      />
    );
    break;
  case 'ContentfulCtaPromo':
    outComponent = <CTAPromo key={key} {...component} />;
    break;
  case 'ContentfulSignUp':
    outComponent = (
      <Signup
        key={key}
        {...component}
        privacyModal={privacyModal}
        termsModal={termsModal}
        apiUrl={mailchimpUrl}
      />);
    break;
  case 'ContentfulVideo':
    outComponent = <Video fullBleed key={key} {...component} />;
    break;
  case 'ContentfulLeftAlignedPromo':
    outComponent = <LeftAlignedPromo key={key} {...component} />;
    break;
  case 'ContentfulMediaKit':
    outComponent = <MediaKit key={key} {...component} />;
    break;
  case 'ContentfulProfileGroup':
    outComponent = <Profiles key={key} {...component} />;
    break;
  case 'ContentfulTitleAndRichText':
    outComponent = <TitleAndText key={key} {...component} />;
    break;
  case 'ContentfulNewsArticleGroup':
    outComponent = <NewsGroup key={key} {...component} />;
    break;
  case 'ContentfulFaqGroup':
    outComponent = <FaqsBlock key={key} {...component} />;
    break;
  default:
    outComponent = <div key={key} />;
  }
  return outComponent;
};

export default GetComponent;



// WEBPACK FOOTER //
// ./src/utils/getComponent.js